// @flow
import React from "react";
import { connect } from "react-redux";
import SelecaoCorretorMonetario from "./SelecaoCorretorMonetario";
import {
  type State,
  i18n,
  getPeriodoUnicoSelecionado,
  getCorretorMonetarioSelecionado,
  getValorBaseDeflatorSelecionado,
  getDataBaseDeflatorSelecionado,
} from "../../../../state";

import {
  type Id,
  ID_PERIODO_ANALISE_HORIZONTAL,
  ID_OPCAO_CORRETOR_MONETARIO_NENHUM,
  ID_VALOR_BASE_DEFLATOR_NENHUM,
  ID_DATA_BASE_DEFLATOR_NENHUM,
} from "../../../../model";

type Props = {
  exibir: boolean,
};

const exibirSelecaoCorrecao: (state: State) => boolean = (state: State) =>
  getPeriodoUnicoSelecionado(state) !== ID_PERIODO_ANALISE_HORIZONTAL;

function SelecaoCorrecaoMonetaria({ exibir }: Props) {
  if (!exibir) {
    return null;
  }

  return (
    <div className="ConfiguracaoMedida">
      <div className="ConfiguracaoMedida--flex">
        <SelecaoCorretorMonetario />
      </div>
    </div>
  );
}

export const criarFuncaoValidacaoSelecaoCorrecaoMonetaria = (
  state: State
) => () => {
  if (!exibirSelecaoCorrecao(state)) {
    return null;
  }

  const { translate } = i18n(state);

  const corretorMonetarioSelecionado: ?Id =
    getCorretorMonetarioSelecionado(state) ?? null;
  const valorBaseDeflatorSelecionado: ?Id =
    getValorBaseDeflatorSelecionado(state) ?? null;
  const dataBaseDeflatorSelecionada: ?Id =
    getDataBaseDeflatorSelecionado(state) ?? null;

  if (
    corretorMonetarioSelecionado !== null &&
    corretorMonetarioSelecionado !== ID_OPCAO_CORRETOR_MONETARIO_NENHUM
  ) {
    const possuiValorBase =
      valorBaseDeflatorSelecionado !== null &&
      valorBaseDeflatorSelecionado !== ID_VALOR_BASE_DEFLATOR_NENHUM;
    const possuiDataBase =
      dataBaseDeflatorSelecionada !== null &&
      dataBaseDeflatorSelecionada !== ID_DATA_BASE_DEFLATOR_NENHUM;

    let msgErro = null;

    if (!possuiValorBase && !possuiDataBase) {
      msgErro = "configuracaoRelatorio.erroConfiguracaoNormalizacaoObrigatoria";
    } else if (possuiValorBase && !possuiDataBase) {
      msgErro =
        "configuracaoRelatorio.erroConfiguracaoNormalizacaoDataBaseObrigatoria";
    } else if (!possuiValorBase && possuiDataBase) {
      msgErro =
        "configuracaoRelatorio.erroConfiguracaoNormalizacaoValorBaseObrigatorio";
    }

    if (msgErro !== null) {
      return {
        selecaoNormalizacao: translate(msgErro),
      };
    }
  }

  return null;
};

export default connect(
  state => ({
    exibir: exibirSelecaoCorrecao(state),
  }),
  {}
)(SelecaoCorrecaoMonetaria);
